import type { SignalTableRow } from "./utils";
import SignalStatusIcon from "./SignalStatusIcon";

type SignalScoreCellProps = {
  score: SignalTableRow[string];
  band: SignalTableRow[string];
};

const getDisplayValue = (value: SignalScoreCellProps["score"]) => {
  if (value === null || value === undefined || value === "") return "-";
  return String(value);
};

export default function SignalScoreCell({ score, band }: SignalScoreCellProps) {
  return (
    <div className="flex items-center gap-2 font-medium text-[#2B4752]">
      <SignalStatusIcon value={band} />
      <span>{getDisplayValue(score)}</span>
    </div>
  );
}
